<template>
  <div class="login-page">
    <section class="login-brand-panel">
      <div class="login-brand-content">
        <img :class="['login-logo', { 'login-logo--default': !branding.logo_url }]" :src="brandLogoUrl" :alt="branding.display_name" />
      </div>
    </section>

    <section class="login-form-panel">
      <div class="login-form-shell">
        <div class="login-heading">
          <span>Acesso {{ branding.display_name }}</span>
          <p>Informe seu e-mail e senha para acessar</p>
        </div>

        <v-form ref="form" v-model="loginForm.validForm" lazy-validation class="login-form" @submit.prevent="login">
          <v-text-field placeholder="Digite seu usuário" label="Usuário" ref="username" outlined
            :rules="[$rules.required]" v-model="loginForm.user.username" prepend-inner-icon="mdi-account-outline"
            class="login-input"></v-text-field>

          <v-text-field outlined label="Senha" :append-icon="loginForm.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            required :rules="[$rules.required]" :type="loginForm.showPassword ? 'text' : 'password'"
            v-model="loginForm.user.password" @click:append="loginForm.showPassword = !loginForm.showPassword"
            prepend-inner-icon="mdi-lock-outline" hide-details="auto" class="login-input mb-6" id="password"></v-text-field>

          <v-btn block x-large color="primary" elevation="0" class="login-submit" :loading="loginForm.loading"
            type="submit">Entrar</v-btn>

          <a class="btn-forgot-password">Esqueci minha senha</a>
        </v-form>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import router from '../router';
//import * as jwt from "jwt-decode";
import jwt_decode from 'jwt-decode';
import defaultLogo from '@/assets/images/logo-smartpin.png';
import { applyBranding, DEFAULT_BRANDING } from '@/services/branding.service';

export default {
  name: "Login",

  data: () => ({
    page: {
      slogan: null,
    },
    branding: { ...DEFAULT_BRANDING },
    username: "",
    password: "",
    loading: false,
    valid: true,
    show: false,
    rules: {
      username: [
        (v) => !!v || "O usuário é obrigatório",
        // (v) =>
        //   (v && v.length <= 25) ||
        //   "O usuário deve ter menos de 10 caracteres",
      ],
      password: [(v) => !!v || "A senha é obrigatória"],
    },
    loginForm: {
      validForm: true,
      showPassword: false,
      loading: false,
      user: {},
    },
  }),

  mounted() {
    if (this.$route.query.username) {
      this.loginForm.user.username = this.$route.query.username;
    }

    const tenantCode = this.resolveTenantCode();
    if (tenantCode) {
      localStorage.setItem('tenant_code', tenantCode);
      this.loadBranding(tenantCode);
    } else if (!this.isMasterLogin()) {
      localStorage.removeItem('tenant_code');
    }
  },

  methods: {
    async loadBranding(tenantCode) {
      try {
        const response = await axios.get('/api/v1/public/branding', { params: { tenant_code: tenantCode } });
        this.branding = applyBranding(response.data.content, this.$vuetify);
      } catch (error) {
        this.branding = applyBranding(DEFAULT_BRANDING, this.$vuetify);
      }
    },
    empty() {
      return (
        !this.$data.loginForm.user.username ||
        !this.$data.loginForm.user.password
      );
    },

    resolveTenantCode() {
      const queryTenantCode = this.$route.query.tenant_code || this.$route.query.tenant || this.$route.query.institution;
      if (queryTenantCode) return `${queryTenantCode}`.toUpperCase();

      if (process.env.VUE_APP_TENANT_CODE) return `${process.env.VUE_APP_TENANT_CODE}`.toUpperCase();

      const hostname = window.location.hostname;
      const ignoredHosts = ['localhost', '127.0.0.1', '0.0.0.0'];
      const ignoredSubdomains = ['app', 'admin', 'www', 'smartpin'];
      const isIpAddress = /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

      if (hostname && !isIpAddress && !ignoredHosts.includes(hostname) && hostname.includes('.')) {
        const subdomain = hostname.split('.')[0];
        if (subdomain && !ignoredSubdomains.includes(subdomain)) return subdomain.toUpperCase();
      }

      return null;
    },

    isMasterLogin() {
      return this.$route.query.master === 'true' || process.env.VUE_APP_ADMIN_MASTER === 'true';
    },

    async login() {

      if (!this.$refs.form.validate()) return;

      const tenantCode = this.resolveTenantCode();

      let data = {
        username: this.loginForm.user.username,
        password: this.loginForm.user.password,
      };

      if (this.isMasterLogin()) data.type = 99;
      if (!this.isMasterLogin() && tenantCode) {
        data.tenant_code = tenantCode;
        localStorage.setItem('tenant_code', tenantCode);
      } else if (!this.isMasterLogin()) {
        localStorage.removeItem('tenant_code');
      }

      localStorage.removeItem('token');
      localStorage.removeItem('user');

      this.$data.loginForm.loading = true;

      try {

        const result = await axios.post('/api/v1/sessions', data);
        const token = result.data.content.token.token;

        localStorage.setItem('token', JSON.stringify(token));

        const decodedToken = jwt_decode(token);
        this.$root.user = decodedToken.data;
        localStorage.setItem('user', JSON.stringify(decodedToken));
        const profileBranding = decodedToken.data && decodedToken.data.current_profile && decodedToken.data.current_profile.branding;
        if (profileBranding) this.branding = applyBranding(profileBranding, this.$vuetify);

        const profileTenantCode = decodedToken.data && decodedToken.data.current_profile
          ? decodedToken.data.current_profile.tenant_code
          : null;

        if (data.tenant_code || profileTenantCode) {
          localStorage.setItem('tenant_code', `${data.tenant_code || profileTenantCode}`.toUpperCase());
        } else {
          localStorage.removeItem('tenant_code');
        }

        // const result = await axios.post('/api/v1/sessions', data);

        // if (!result.data.status) throw new Error();

        // localStorage.setItem('token', JSON.stringify(result.data.content));

        // var dataUser = jwt(result.data.content.token);

        // console.log('dataUser', dataUser)

        // this.$root.user = dataUser.data;
        // localStorage.setItem('user', JSON.stringify(dataUser));

        router.push("/home");

      } catch (error) {
        console.log('error ', error)
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
        this.$data.loginForm.user.password = "";
      } finally {
        this.$data.loginForm.loading = false;
      }
    },

    /*
    async login() {

      if (!this.$refs.form.validate()) return;

      let data = {
        email: this.loginForm.user.email,
        password: this.loginForm.user.password,
       // grant_type: "password",
       // client_id: "web_app"
       type: 2,
      };

      const dataParams = new URLSearchParams(data);

      this.$data.loginForm.loading = true;

      try {

       // const result = await axios.post('/api/authenticate/signIn', dataParams, { 
        const result = await axios.post('/api/admin/login', dataParams, { 
          headers: {
            "Content-Type": "application/x-www-form-urlencoded", "scope": "openid",
          },
          withCredentials: true,
        });

        if (!result.data.token) throw new Error();

        localStorage.setItem('token', JSON.stringify(result.data.token));
        localStorage.setItem('refresh_token', JSON.stringify(result.data.refreshToken));

        var dataUser = jwt(result.data.token);

        console.log('dataUser', dataUser)

        this.$root.user = dataUser;
        localStorage.setItem('user', JSON.stringify(dataUser));

        router.push("/home");

      } catch (error) {
        console.log('error ', error)
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
        this.$data.loginForm.user.password = "";
      } finally {
        this.$data.loginForm.loading = false;
      }
    },
    */

    forgotPassword() {
      this.$router.replace("/solicitar-senha");
    },

  },
  computed: {
    brandLogoUrl() { return this.branding.logo_url || defaultLogo; },
  },
};
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(420px, 46vw) 1fr;
  background: #f6f8fb;
}

.login-brand-panel {
  position: relative;
  display: flex;
  align-items: center;
  padding: 64px;
  overflow: hidden;
  background: #0f172a;
  color: #ffffff;

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(90deg, rgba(15, 23, 42, 0.78) 0%, rgba(15, 23, 42, 0.48) 48%, rgba(15, 23, 42, 0.2) 100%),
      url("~@/assets/images/login-access-school.webp");
    background-position: 52% center;
    background-size: cover;
    opacity: 0.92;
  }

  &:after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at 20% 24%, rgba(11, 99, 206, 0.38), rgba(11, 99, 206, 0) 36%),
      linear-gradient(135deg, rgba(5, 84, 181, 0.24), rgba(15, 23, 42, 0.7) 58%),
      repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.045) 0 1px, transparent 1px 24px);
  }
}

.login-brand-content {
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 560px;
  min-height: 100%;
  flex-direction: column;
  justify-content: flex-start;
}

.login-logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 172px;
  height: auto;
  object-fit: contain;
}

.login-logo--default { filter: brightness(0) invert(1); }

.login-form-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.login-form-shell {
  width: 100%;
  max-width: 420px;
}

.login-heading {
  margin-bottom: 34px;
}

.login-heading span {
  display: block;
  max-width: 360px;
  color: #0f172a;
  font-size: 38px;
  font-weight: 760;
  line-height: 1;
}

.login-heading p {
  margin: 12px 0 0;
  color: #64748b;
  font-size: 14px;
}

.login-form {
  width: 100%;
}

.login-input ::v-deep .v-input__slot {
  min-height: 54px !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.login-submit {
  height: 52px !important;
  border-radius: 8px;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 12px 24px rgba(5, 84, 181, 0.22) !important;
}

.btn-forgot-password {
  display: inline-block;
  margin-top: 22px;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.title-login {
  color: var(--v-black-base);
  // font-family: Montserrat;
  font-family: 'Avenir LT Std';
  font-size: 44px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px
}

.btn-login {
  text-transform: none !important;
  letter-spacing: 1px;
  font-weight: 400;
}

@media only screen and (max-width: 960px) {
  .login-page {
    display: block;
    background: #ffffff;
  }

  .login-brand-panel {
    min-height: 230px;
    padding: 34px 28px;
  }

  .login-brand-content {
    min-height: 0;
  }

  .login-logo {
    position: relative;
    top: auto;
    left: auto;
    width: 140px;
    margin: 0;
  }

  .login-form-panel {
    align-items: flex-start;
    padding: 34px 28px 48px;
  }

  .login-heading span {
    font-size: 30px;
  }
}
</style>
